<template>
  <div>
    <h3>Attributes:</h3>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="value" label="参数" width="100"> </el-table-column>
      <el-table-column prop="describe" label="说明" width="350"> </el-table-column>
      <el-table-column prop="type" label="类型" width="200"> </el-table-column>
      <el-table-column prop="Option" label="可选值" width="300"> </el-table-column>
      <el-table-column prop="default" label="默认值" width="150"> </el-table-column>
      <el-table-column prop="required" label="必填" width="50"> </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        {
          value: " value",
          describe: "值",
          type: "string|number",
          Option: "-",
          default: "-",
          required: "true"
        },
        {
          value: " selectOptions",
          describe: "下拉框的选项数据",
          type: "array",
          Option: "-",
          default: "-",
          required: "true"
        },
        {
          value: " appendToBody",
          describe: "是否把点击后的弹框插入到body下",
          type: "boolean",
          Option: "-",
          default: "true",
          required: "false"
        },
        {
          value: " title",
          describe: "描述文字",
          type: "string",
          Option: "-",
          default: "-",
          required: "true"
        },
        {
          value: " titleSize",
          describe: "描述文字大小",
          type: "string",
          Option: "auto/xxx%",
          default: "auto",
          required: "false"
        },
        {
          value: " popperClass",
          describe: "下拉框类名",
          type: "string",
          Option: "-",
          default: "''",
          required: "false"
        },
        {
          value: " placeholder",
          describe: "占位符文字",
          type: "string",
          Option: "-",
          default: "请输入",
          required: "false"
        },
        {
          value: " themeKey",
          describe: "主题色关键字",
          type: "String",
          Option: "bigScreen/portal",
          default: "bigScreen",
          required: "false"
        }
      ]
    }
  }
}
</script>

<style>
</style>